import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TranslateModule} from "@ngx-translate/core";
import {MatCardModule} from "@angular/material/card";
import {MatPaginatorModule} from "@angular/material/paginator";
import {ParticipantDetailCardModule} from "@pages/user/partials/participant-detail-card/participant-detail-card.module";
import {MatButtonModule} from "@angular/material/button";
import {MatTableModule} from "@angular/material/table";
import {MatDividerModule} from "@angular/material/divider";
import {RouterModule} from "@angular/router";
import {CardOverlayModule} from "@pages/user/partials/card-overlay/card-overlay.module";
import {MatSortModule} from "@angular/material/sort";
import {MatSnackBarModule} from "@angular/material/snack-bar";
import {UserDashboardComponent} from "@pages/user/user-dashboard/user-dashboard.component";
import {UserSurveyTableModule} from "@pages/user/user-dashboard/partials/user-survey-table/user-survey-table.module";

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    RouterModule,
    MatCardModule,
    MatDividerModule,
    MatButtonModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatSnackBarModule,
    CardOverlayModule,
    ParticipantDetailCardModule,
    UserSurveyTableModule,
  ],
  declarations: [UserDashboardComponent],
  exports: [UserDashboardComponent],
  providers: []
})
export class UserDashboardModule { }
